import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  adminCreateAction,
  adminEditAction,
} from "../Redux/Action/ManageAdminAction";
import StudentsImagesModal from "./StudentsImagesModal";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "../Util/HelperFunction";
import { CreateAdminValidateSchema } from "../Util/formValidations";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CreateAdminModal = ({ showCreate, handleCloseCreate, editdata }) => {
  const schoolData = useSelector((state) => state?.authSlice?.schoolDetail);
  const dataofstore = useSelector(
    (state) => state?.authSlice.userData?.payload
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const [studentModalShow, setStudentModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const initialData = {
    firstName: "",
    surName: "",
    email: "",
    department: "",
    superFicialRole: "",
    image: selectedImage || "",
    title: "",
    customTitle: "",
    permissionToManageAdmins: true,
    permissionToUpdateYearGroups:
      schoolData?.permissionToUpdateYearGroups === false ? false : true,
  };

  const formik = useFormik({
    initialValues: editdata
      ? {
          ...initialData,
          ...editdata,
          title: editdata.title
            ? ["Mr", "Mrs", "Miss", "Ms", "Dr"].includes(editdata.title)
              ? editdata.title
              : "custom"
            : "",
          customTitle:
            editdata.title &&
            !["Mr", "Mrs", "Miss", "Ms", "Dr"].includes(editdata.title)
              ? editdata.title
              : "",
          permissionToManageAdmins: editdata?.permissionToManageAdmins ?? true,
          permissionToUpdateYearGroups:
            editdata?.permissionToUpdateYearGroups ?? true,
        }
      : initialData,
    enableReinitialize: true,
    validationSchema: CreateAdminValidateSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      const finalTitle =
        values.title === "custom" ? values.customTitle : values.title;
      const modifyData = {
        image: selectedImage || values.image,
        surName: values.surName,
        department: values.department,
        superFicialRole: values.superFicialRole,
        firstName: values.firstName,
        permissionToManageAdmins: values.permissionToManageAdmins,
        permissionToUpdateYearGroups: values.permissionToUpdateYearGroups,
        title: finalTitle,
      };

      if (!editdata) {
        modifyData.email = values.email;
      } else {
        modifyData.id = values._id;
      }

      const action = editdata ? adminEditAction : adminCreateAction;
      const response = await dispatch(action(modifyData));

      if (response?.payload?.statusCode === 200) {
        toast.success(response?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        setIsLoading(false);
        formik.resetForm();
        handleCloseCreate();
      } else {
        toast.error(response?.payload?.message);
        setIsLoading(false);
      }
    },
  });






  const handleCloseStudentModal = () => setStudentModalShow(false);
  const handleOpenStudentModal = () => setStudentModalShow(true);

  const tooltipText =
    "Because your account doesn't have this permission, you're unable to grant it to others.";
  const renderText = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <span
        style={{
          fontFamily: "Raleway, sans-serif",
          fontSize: "14px",
          color: "#333",
          display: "inline-block",
        }}
      >
        {tooltipText}
      </span>
    </Tooltip>
  );

  return (
    <>
      <Modal
        size="lg"
        show={showCreate}
        onHide={handleCloseCreate}
        className="comn-modal-set create"
        centered
      >
        <Modal.Header className="d-block" style={{ border: 0 }}>
          <Row>
            <Col lg={12} className="d-flex justify-content-center mb-4">
              <div>
                <Modal.Title className="p-0">
                  {editdata ? "Edit Admin" : "Create a New Admin"}
                </Modal.Title>
                {!editdata && (
                  <p className="text-center mb-0">Create a new Admin profile</p>
                )}
              </div>
            </Col>
          </Row>
          <div className="modal-right">
            <button className="menu-dots" onClick={handleCloseCreate}>
              <img src={require("../Assets/Images/dotsweb.svg").default}  alt="Menu options" />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <Form onSubmit={formik.handleSubmit}>
                <Form.Group className="mb-3" controlId="formImage">
                  <Form.Label>Profile (optional)</Form.Label>
                  <div className="upld-vd-box mt-4 mb-4">
                    <div className="upld-img-side">
                      {selectedImage || formik?.values.image ? (
                        <div>
                          <img
                            src={selectedImage || formik?.values.image}
                            className="img-fluid"
                            alt="CreateAdminModal graphic"
                          />
                          
                        </div>
                      ) : (
                        <>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="80"
                            height="80"
                            viewBox="0 0 80 80"
                            fill="none"
                          >
                            <g clipPath="url(#clip0)">
                              <path
                                d="M33.3337 53.3333H46.667C48.5003 53.3333 50.0003 51.8333 50.0003 50V33.3333H55.3003C58.267 33.3333 59.767 29.7333 57.667 27.6333L42.367 12.3333C41.067 11.0333 38.967 11.0333 37.667 12.3333L22.367 27.6333C20.267 29.7333 21.7337 33.3333 24.7003 33.3333H30.0003V50C30.0003 51.8333 31.5003 53.3333 33.3337 53.3333ZM20.0003 60H60.0003C61.8337 60 63.3337 61.5 63.3337 63.3333C63.3337 65.1667 61.8337 66.6667 60.0003 66.6667H20.0003C18.167 66.6667 16.667 65.1667 16.667 63.3333C16.667 61.5 18.167 60 20.0003 60Z"
                                fill="#d200a5"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="80" height="80" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <div className="upld-text">
                            <h3>Update Photo</h3>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="upld-btn-side">
                      <h2>Select</h2>
                      <p>550 x 1200 recommended</p>
                      <div
                        className="upload mt-5"
                        onClick={handleOpenStudentModal}
                      >
                        <Link to="#">Update Photo</Link>
                      </div>
                    </div>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formTitle">
                  <Form.Label>Title</Form.Label>
                  <Form.Select
                    className="input-set"
                    name="title"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.title}
                  >
                    <option value="">Select Title</option>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Miss">Miss</option>
                    <option value="Ms">Ms</option>
                    <option value="Dr">Dr</option>
                    <option value="custom">Other</option>
                  </Form.Select>
                  {formik.submitCount > 0 && formik.errors.title && (
                    <div className="error text-danger">
                      {formik.errors.title}
                    </div>
                  )}
                  {formik.values.title === "custom" && (
                    <div className="mt-2">
                      <Form.Label>Other Title</Form.Label>
                      <Form.Control
                        type="text"
                        className="input-set"
                        placeholder="Enter other title"
                        name="customTitle"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.customTitle}
                      />
                      {formik.submitCount > 0 && formik.errors.customTitle && (
                        <div className="error text-danger">
                          {formik.errors.customTitle}
                        </div>
                      )}
                    </div>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="firstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    className="input-set"
                    placeholder="Type Here"
                    name="firstName"

                    onChange={(e) =>
                      formik.setFieldValue(
                        "firstName",
                        capitalizeFirstLetter(e.target.value)
                      )
                    }
                    onBlur={formik.handleBlur}
                    value={formik.values.firstName}
                  />
                  {formik.submitCount > 0 && formik.errors.firstName && (
                    <div className="error text-danger">
                      {formik.errors.firstName}
                    </div>
                  )}
                </Form.Group>
                <Form.Group className="mb-3" controlId="surName">
                  <Form.Label>Surname</Form.Label>
                  <Form.Control
                    type="text"
                    className="input-set"
                    placeholder="Type Here"
                    name="surName"

                    onChange={(e) =>
                      formik.setFieldValue(
                        "surName",
                        capitalizeFirstLetter(e.target.value)
                      )
                    }
                    onBlur={formik.handleBlur}
                    value={formik.values.surName}
                  />
                  {formik.submitCount > 0 && formik.errors.surName && (
                    <div className="error text-danger">
                      {formik.errors.surName}
                    </div>
                  )}
                </Form.Group>
                
                <Form.Label style={{ marginTop: 2 }}>Permissions</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="permissionToUpdateYearGroups"
                >
                  <Form.Label style={{ marginBottom: 0, fontSize: "12px" }}>
                    Allow this Admin to change a Learner’s Year Group
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {dataofstore?.role == "SchoolAdmin" ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          schoolData?.permissionToUpdateYearGroups === false ? (
                            renderText
                          ) : (
                            <></>
                          )
                        }
                      >
                        <div>
                          <Form.Check
                            type="switch"
                            id="permissions-switch1"
                            name="permissionToUpdateYearGroups"
                            className="mt-1"
                            disabled={
                              schoolData?.permissionToUpdateYearGroups === false
                            }
                            checked={formik.values.permissionToUpdateYearGroups}
                            onChange={formik.handleChange}
                            style={{
                              transform: "scale(1.5)",
                              transformOrigin: "right center",
                              marginLeft: "20px",
                            }}
                          />
                        </div>
                      </OverlayTrigger>
                    ) : (
                      <Form.Check
                        type="switch"
                        id="permissions-switch1"
                        name="permissionToUpdateYearGroups"
                        className="mt-1"
                        checked={formik.values.permissionToUpdateYearGroups}
                        onChange={formik.handleChange}
                        style={{
                          transform: "scale(1.5)",
                          transformOrigin: "right center",
                          marginLeft: "20px",
                        }}
                      />
                    )}
                  </div>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="permissionToManageAdmins"
                >
                  <Form.Label style={{ marginBottom: 0, fontSize: "12px" }}>
                    Allow this Admin to create and manage Admins
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Form.Check
                      type="switch"
                      id="permissions-switch"
                      name="permissionToManageAdmins"
                      className="mt-1"
                      checked={formik.values.permissionToManageAdmins}
                      onChange={formik.handleChange}
                      style={{
                        transform: "scale(1.5)",
                        transformOrigin: "right center",
                        marginLeft: "20px",
                      }}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-3 mt-3" controlId="department">
                  <Form.Label>Department (optional)</Form.Label>
                  <Form.Control
                    type="text"
                    className="input-set"
                    placeholder="Type Here"
                    name="department"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.department}
                  />
                </Form.Group>
                <Form.Group className="mb-3 mt-3" controlId="superFicialRole">
                  <Form.Label>Role (optional)</Form.Label>
                  <Form.Control
                    type="text"
                    className="input-set"
                    placeholder="Type Here"
                    name="superFicialRole"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.superFicialRole}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    className="input-set"
                    placeholder="Type Here"
                    name="email"
                    readOnly={!!editdata}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  {formik.submitCount > 0 && formik.errors.email && (
                    <div className="error text-danger">
                      {formik.errors.email}
                    </div>
                  )}
                </Form.Group>
                <Modal.Footer className="border-none justify-content-center">
                  <Button
                    variant="primary"
                    className="modal-f-btn"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : editdata ? "Update" : "Create"}
                  </Button>
                </Modal.Footer>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <StudentsImagesModal
        studentModalshow={studentModalShow}
        handleCloseStudentModal={handleCloseStudentModal}
        setSlectedImage={setSelectedImage}
      />
    </>
  );
};

export default CreateAdminModal;
